import React from "react";
import { useState } from "react";
import "./Portfolio.css";
import Project from "./Project";

function Portfolio() {
  return (
    <div className="portfolio">
      <h1>PORTFOLIO</h1>
      <div className="portfolio__projectBox">
        <Project
          name="Google Maps Clone"
          image={require("./google-maps-challenge.png")}
          linkToProject="https://github.com/priyanshusaraf/google-maps-project-summer"
        />
        <Project
          name="Netflix Clone"
          image={require("./Capture.JPG")}
          linkToProject="https://netflix-clone-5966a.web.app"
        />
      </div>
    </div>
  );
}

export default Portfolio;
